














































import Vue from "vue";

// Model
import { CashTypeEnum, cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";
import { GetBranchReportReqData } from "@/model/communication/branchReport/GetBranchReportReqData";
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
export default Vue.extend({
    data() {
        return {
            CashTypeEnum,

            filters: {
                startDate: null,
                endDate: null,
                branchName: null,
                currency: null,
                cashType: null,
            },
            selectedBranchName: "Default",
        };
    },
    components: {
        DateTimeRangePicker,
    },
    props: {
        loading: Boolean,
        value: {},
        availableBranchNames: Array,
        availableCurrencies: Array,
    },
    computed: {
        selectedCurrency: {
            get() {
                return (this.filters as GetBranchReportReqData).currency;
            },
            set(newValue: string) {
                (this.filters as GetBranchReportReqData).currency = newValue;
                this.$emit("input", this.filters);
            },
        },
    },
    mounted() {
        this.filters = this.value;
    },
    methods: {
        cashTypeEnumLabel,
        handleInput(value) {
            this.$emit("input", value);
        },
        changedBranch(newValue) {
            (this.filters as GetBranchReportReqData).branchName = newValue.value;
            this.$emit("input", this.filters);
        },
    },
});
